import { VFC } from 'react';

import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportKyckrBusinessLookup } from 'dashboard/models/report/integration/kyckr-business-lookup';

interface KyckrBusinessLookuptProps {
  report: ReportKyckrBusinessLookup;
  isRedacted: boolean;
}

const KyckrBusinessLookup: VFC<KyckrBusinessLookuptProps> = ({
  report: {
    attributes: {
      query: {
        'country-code': countryCode,
        'company-name': companyName,
        'company-number': companyNumber,
        'registration-authority': registrationAuthority,
        'order-ref': orderRef,
      },
    },
  },
  isRedacted,
}: KyckrBusinessLookuptProps) => {
  return (
    <AttributeGrid>
      <AttributeItem
        title='Country Code'
        value={countryCode}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-kyckr-business-lookup__country-code'
      />
      <AttributeItem
        title='Company Name'
        value={companyName}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-kyckr-business-lookup__company-name'
      />
      <AttributeItem
        title='Company Number'
        value={companyNumber}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-kyckr-business-lookup__company-number'
      />
      <AttributeItem
        title='Registration Authority'
        value={registrationAuthority}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-kyckr-business-lookup__registration-authority'
      />
      <AttributeItem
        title='Order Reference'
        value={orderRef}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-kyckr-business-lookup__order-reference'
      />
    </AttributeGrid>
  );
};

export default KyckrBusinessLookup;
